import { useTranslation } from 'react-i18next'
import { Button } from '../../../../components'
import { normalizeTime } from '../../../../utils/receivingConfig'

const T = 'receiving_config.franjas'
const ORDER = [1, 2, 3, 4, 5, 6, 0]

export const FranjasCard = ({ franjas = [], onAdd, onEdit, onToggleActive }) => {
  const { t } = useTranslation()
  const names = t(`${T}.weekdays_short`, { returnObjects: true })
  const fullNames = t(`${T}.weekdays_full`, { returnObjects: true })
  return (
    <section className="bg-white border border-gray-200 rounded-md p-4">
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-base font-semibold text-gray-900">{t(`${T}.title`)}</h3>
        <Button type="secondary" onClick={onAdd}>
          {t(`${T}.add`)}
        </Button>
      </div>
      {franjas.length === 0 ? (
        <p className="text-sm text-gray-500">{t(`${T}.empty`)}</p>
      ) : (
        <table className="min-w-full text-sm">
          <thead>
            <tr className="text-left text-gray-500">
              <th className="py-1 pr-4">{t(`${T}.headers.label`)}</th>
              <th className="py-1 pr-4">{t(`${T}.headers.weekdays`)}</th>
              <th className="py-1 pr-4">{t(`${T}.headers.window`)}</th>
              <th className="py-1 pr-4">{t(`${T}.headers.status`)}</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {franjas.map(f => {
              const days = new Set((f.weekdays || []).map(Number))
              return (
                <tr key={f.id ?? f._tempKey} className={`border-t border-gray-100 ${f.active ? '' : 'text-gray-400'}`}>
                  <td className="py-2 pr-4 font-medium">{f.label}</td>
                  <td className="py-2 pr-4">
                    <span className="inline-flex gap-1">
                      {ORDER.map(d => (
                        <span
                          key={d}
                          title={fullNames[d]}
                          className={`w-5 h-5 rounded-full text-xs inline-flex items-center justify-center ${days.has(d) ? 'bg-yellow-500 text-white' : 'bg-gray-100 text-gray-400'}`}
                        >
                          {names[d]}
                        </span>
                      ))}
                    </span>
                  </td>
                  <td className="py-2 pr-4">
                    {normalizeTime(f.starts_at)}–{normalizeTime(f.ends_at)}
                  </td>
                  <td className="py-2 pr-4">
                    <span
                      className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${f.active ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-600'}`}
                    >
                      {t(f.active ? `${T}.active` : `${T}.retired`)}
                    </span>
                  </td>
                  <td className="py-2 text-right whitespace-nowrap">
                    <button type="button" className="text-indigo-600 hover:underline mr-3" onClick={() => onEdit(f)}>
                      {t(`${T}.edit`)}
                    </button>
                    {f.id != null && (
                      <button type="button" className={`${f.active ? 'text-red-600' : 'text-green-700'} hover:underline`} onClick={() => onToggleActive(f)}>
                        {t(f.active ? `${T}.retire` : `${T}.reactivate`)}
                      </button>
                    )}
                  </td>
                </tr>
              )
            })}
          </tbody>
        </table>
      )}
    </section>
  )
}
